import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {RecieptVouchers} from '../reciept_vouchers';
import {RecieptVouchersService} from '../reciept_vouchers.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {Http, RequestOptions, ResponseContentType} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {formatDate} from "ngx-bootstrap/chronos";
import {CustomerService} from "../../../setting/customers/customer.service";
import {ItemService} from "../../../setting/items/items.service";
import {AccountsService} from "../../accounts/accounts.service";
import {AccountsShowComponent} from "../../accounts/accounts-show/accounts-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {PurchasesShowComponent} from "../../../pro/purchases/purchases-show/purchases-show.component";
import {ReturninvoicesShowComponent} from "../../../pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {InvoicesShowComponent} from "../../../pos/invoices/invoices-show/invoices-show.component";
import {JournalsShowComponent} from "../../journals/journals-show/journals-show.component";
import {ExpenseVouchersShowComponent} from "../../expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {RefundsShowComponent} from '../../../pro/refunds/refunds-show/refunds-show.component';

@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MyInputsModule, MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        RecieptVouchersShowComponent
    ],
    entryComponents: [
        RecieptVouchersShowComponent
    ],
    exports: [],
    providers: [SharedService, RecieptVouchersService, MessageService, ConfirmationService,AccountsService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-invoices-show',
    templateUrl: './reciept_vouchers-show.component.html',
    styleUrls: ['./reciept_vouchers-show.component.scss'],
    providers: [RecieptVouchersService, ConfirmationService, MessageService, CustomerService,ItemService,AccountsService]
})

export class RecieptVouchersShowComponent implements OnInit, AfterViewInit {
  id: string;
  invoice:any;
  oldinvoice:any;
  restoreInv:any;
  @Input() refShow;
  bank: any[] = [];
  // picture:string;x
  applog: AppLogComponent;
  parent_name: any;
  @Input() scrId;
  modalRef: NgbModalRef;
  parent:any;
  @Input() modelName;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
  defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
  typeVal = [{'val': 1, 'title': 'Other'}, {'val': 3, 'title': 'refunds'}, {'val': 4, 'title': 'Invoices'}];

  allinvdetails: any[] = [];
  today = formatDate(new Date(),"YYYY-MM-DD");

  Selectedpaymentway: any = 0;
  Selectedpaymentdetails: any = "";
  Selectedpaymentamount: any = 0;

  allpaid: any=0.0;
  allremain: any=0.0;
  allquty:any = 0;
  allcost_b_tax:any = 0;
  allcost_a_tax:any = 0;
  alltaxes:any = 0;
  allcostsforone:any = 0;
  alldiscountvalue:any = 0;

  Selecteditem: any;
  Selecteditemcost: any = 0.0;
  Selecteditemquty: any = 0.0;
  Selecteditemtotal_b_tax: any;
  Selecteditemtotal_a_tax: any;
  Selecteditemtax: any;
  Selecteditemdetails: any;

  itemCount: any[] = [];
  itemCountPayment: any[] = [];


  invoice_arr: any[] = [];
  invoice_list_arr: any[] = [];
  invoice_payment_arr: any[] = [];




  deletedrow: any[] = [];
  deletedrowPayment: any[] = [];
  selectedrow: any[] = [];

  customers: any[] = [];
  customersselected: any[] = [];

  Selected_items: any[] = [];
  Selected_payment: any[] = [];
  items: SelectItem[] = [];
  Selected_items_db: string[] = [];
  selectedItem: string[] = [];
  selectedPayment: string[] = [];

  allitems: any = [];
  items_enhance: any = [];
  payment_enhance: any = [];
  //invoice_typeVal = [{'val': 1, 'title': 'نقدية'}, {'val': 2, 'title': 'آجلة'}];
  invoice_typeVal: any;
  showDocNo = 1;
  cities: any[] = [];
  year_post_disabled = false;
  currency: any[] = [];
  docs: any[] = [];
  form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private invoiceService: RecieptVouchersService,
                private accountsService: AccountsService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private customerservice: CustomerService,
                private itemservice: ItemService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(RecieptVouchersShowComponent);
        this.sharedservice.setButtons([
          {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
          {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
          {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
          {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
          {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);

      this.oldinvoice = false;
      this.invoice = false;

        this.sharedservice.setModelName('reciept_vouchers');
        this.itemservice.getAllItems().subscribe(
        items => {
          this.allitems = items.itemslist;
          this.items_enhance = items.itemstable;
        });
        this.accountsService.getAllGroups(0).subscribe(
          group => {
            this.allinvdetails = group;
        });

    }
    print() {
      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      const tokenapi = userdata.api_token;
      const options = new RequestOptions({responseType: ResponseContentType.Blob });
      window.open(appConfig.apiUrl + 'reciept_vouchers/print/'+this.id+'?token='+ tokenapi )
    }

    showParent(){
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(CurrenciesShowComponent, options);
        this.modalRef.componentInstance.scrId = this.parent;

        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.invoice;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if (!this.scrId) {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');


        if (this._editButton) {
          this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/reciept_vouchers/edit', this.id]);
          });
        }
        if (this._deleteButton) {

          this._deleteButton.onclick = ((e: any) => {
            e.preventDefault();
            this.deleteRecieptVouchers(this.invoice);
          });
        }
        if (this._newButton) {

          this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/reciept_vouchers']);
          });

        }
        if (this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/reciept_vouchers/search']);
          });

        }

        if (this._printButton) {
          this._printButton.onclick = ((e: any) => {
            e.preventDefault();
            this.print();
          });

        }
      }
    }

  changedoctype() {
    let doctype = this.form.controls['document_type'].value;
    this.showDocNo = doctype;
    this.docs = [];
    if(doctype == 4){
      this.customerservice.getAllInv().subscribe(
        customers => {
          this.docs = customers.invoiceslist;

        });
    } else if (doctype == 3){
      this.accountsService.getDocs(3).subscribe(
        list => {
          this.docs = list;
        });
    }

  }

    ngOnInit() {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });

        this.invoiceService.getAllCurrencies().subscribe(
            bank => {
                this.bank = bank;
            });

      this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.parent_name = params['invoice_parent_group'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),

          recipient_name: new FormControl({value: '', disabled: true}),
          statement: new FormControl({value: '', disabled: true}),
          document_type: new FormControl({value: '', disabled: true}),
          document_no: new FormControl({value: '', disabled: true}),
          date_time: new FormControl({value: '', disabled: true}),
          post_status: new FormControl({value: '', disabled: true}),
          journal_id: new FormControl({value: '', disabled: true})

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
          this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }



            this.invoiceService.getById(this.id).subscribe(
              invoice => {
                this.invoice_arr = invoice.invoice;
                this.invoice_list_arr = invoice.itemsdetails;
                this.invoice_payment_arr = invoice.itemspayment;
                this.selectedItem = invoice.selecteditems;

                let post_status_t =  invoice.invoice.post_status;
                if(post_status_t == 1){
                  this.year_post_disabled = true;
                  console.log("11111");
                }else{
                  this.year_post_disabled = false;
                  console.log("22222");
                }

                this.id = invoice.invoice.id;
                this.invoice = invoice.invoice;
                this.form.patchValue({
                  id : invoice.invoice.id,
                  document_type: invoice.invoice.document_type,
                  date_time: invoice.invoice.date_time,
                  recipient_name: invoice.invoice.recipient_name,
                  document_no: invoice.invoice.document_no,
                  statement: invoice.invoice.statement,
                  post_status: invoice.invoice.post_status,
                  journal_id: invoice.invoice.journal_id

              });

                this.changedoctype();

                this.customerservice.getAllCustomers().subscribe(
                  customers => {
                    this.customers = customers.customershow;
                    this.customersselected=[this.customers[invoice.invoice.customer_id]];
                  });


                for(let i=0; i<this.invoice_list_arr.length; i++){

                  let iserte = {value: this.invoice_list_arr[i].account_no, inx: i , statement:this.invoice_list_arr[i].statement , amount:this.invoice_list_arr[i].amount};
                  this.Selected_items[i] = iserte;
                    //console.log(this.invoice_list_arr[i]);
                  //this.selectedItem[this.invoice_list_arr[i].item_id] = this.items_enhance[this.invoice_list_arr[i].item_id];
                }
                this.itemCount = Array(this.Selected_items.length ).fill(2);

                for(let i=0; i<this.invoice_payment_arr.length; i++){

                  let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                  this.Selected_payment[i] = iserte;
                }
                this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

                this.changallpaid();
                this.changeallremain();



              }, error => {
                console.log(error);
              }
            );


        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

          this.invoiceService.getById(this.scrId).subscribe(
            invoice => {
              this.invoice_arr = invoice.invoice;
              this.invoice_list_arr = invoice.itemsdetails;
              this.invoice_payment_arr = invoice.itemspayment;
              this.selectedItem = invoice.selecteditems;

              this.id = invoice.invoice.id;
              this.invoice = invoice.invoice;
              this.form.patchValue({
                id : invoice.invoice.id,
                document_type: invoice.invoice.document_type,
                date_time: invoice.invoice.date_time,
                recipient_name: invoice.invoice.recipient_name,
                document_no: invoice.invoice.document_no,
                statement: invoice.invoice.statement

              });

              this.changedoctype();

              this.customerservice.getAllCustomers().subscribe(
                customers => {
                  this.customers = customers.customershow;
                  this.customersselected=[this.customers[invoice.invoice.customer_id]];
                });


              for(let i=0; i<this.invoice_list_arr.length; i++){

                let iserte = {value: this.invoice_list_arr[i].account_no, inx: i , statement:this.invoice_list_arr[i].statement , amount:this.invoice_list_arr[i].amount};
                this.Selected_items[i] = iserte;
                //console.log(this.invoice_list_arr[i]);
                //this.selectedItem[this.invoice_list_arr[i].item_id] = this.items_enhance[this.invoice_list_arr[i].item_id];
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);

              for(let i=0; i<this.invoice_payment_arr.length; i++){

                let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                this.Selected_payment[i] = iserte;
              }
              this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

              this.changallpaid();
              this.changeallremain();
              // console.log(this.Selected_items);
              // console.log(this.selectedItem);


            }, error => {
              console.log(error);
            }
          );


        }
        if (this.delId) {
          //console.log(this.delId);

            this.oldData = false;
            this.newData = false;
          this.newDatap = !this.newDatap ;
          this.invoiceService.getTrashedById(this.delId).subscribe(
            invoice => {
              this.invoice_arr = invoice.invoice;
              this.invoice_list_arr = invoice.itemsdetails;
              this.invoice_payment_arr = invoice.itemspayment;
              this.selectedItem = invoice.selecteditems;

              this.id = invoice.invoice.id;
              this.invoice = invoice.invoice;
              this.form.patchValue({
                id : invoice.invoice.id,
                document_type: invoice.invoice.document_type,
                date_time: invoice.invoice.date_time,
                recipient_name: invoice.invoice.recipient_name,
                document_no: invoice.invoice.document_no,
                statement: invoice.invoice.statement

              });

              this.changedoctype();

              this.changedoctype();

              if(invoice.invoice.invoice_type == 1){
                this.invoice_typeVal = "نقدية" ;

              }else{
                this.invoice_typeVal =  "آجلة" ;
              }

              //this.customersselected=[this.customers[invoice.invoice.customer_id]];

              for(let i=0; i<this.invoice_list_arr.length; i++){

                let iserte = {value: this.invoice_list_arr[i].account_no, inx: i , statement:this.invoice_list_arr[i].statement , amount:this.invoice_list_arr[i].amount};
                this.Selected_items[i] = iserte;
                //console.log(this.invoice_list_arr[i]);
                //this.selectedItem[this.invoice_list_arr[i].item_id] = this.items_enhance[this.invoice_list_arr[i].item_id];
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);

              for(let i=0; i<this.invoice_payment_arr.length; i++){

                let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};;
                this.Selected_payment[i] = iserte;
              }
              this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

              this.changallpaid();
              this.changeallremain();
              // console.log(this.Selected_items);
              // console.log(this.selectedItem);


            }, error => {
              console.log(error);
            }
          );
        }

        if (this.oldData && this.newData) {
          this.restoreInv = this.oldData.invoice;
          this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);
          this.restoreInv.inv_payment_details = JSON.stringify(this.oldData.itemspayment);
            this.invoice = this.newData.invoice;
            this.oldinvoice = this.oldData.invoice;
          this.invoice_arr = this.newData.invoice;
          this.invoice_list_arr = this.newData.itemsdetails;
          this.invoice_payment_arr = this.newData.itemspayment;
          this.selectedItem = this.newData.selecteditems;

          let post_status_t =  this.newData.invoice.post_status;
          if(post_status_t == 1){
            this.year_post_disabled = true;
          }else{
            this.year_post_disabled = false;
          }

          this.id = this.newData.invoice.id;
          this.invoice = this.newData.invoice;
          this.form.patchValue({
            id : this.invoice.id,
            document_type: this.invoice.document_type,
            date_time: this.invoice.date_time,
            recipient_name: this.invoice.recipient_name,
            document_no: this.invoice.document_no,
            statement: this.invoice.statement,
            post_status: this.invoice.post_status,
            journal_id: this.invoice.journal_id

          });

          this.changedoctype();

          this.customerservice.getAllCustomers().subscribe(
            customers => {
              this.customers = customers.customershow;
              this.customersselected=[this.customers[this.invoice.customer_id]];
            });


          for(let i=0; i<this.invoice_list_arr.length; i++){
            let iserte = {value: this.invoice_list_arr[i].account_no, inx: i , statement:this.invoice_list_arr[i].statement , amount:this.invoice_list_arr[i].amount};
            this.Selected_items[i] = iserte;
            this.selectedItem.push(this.invoice_list_arr[i].account_no);
          }
          this.itemCount = Array(this.Selected_items.length ).fill(2);

          for(let i=0; i<this.invoice_payment_arr.length; i++){

            let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
            this.Selected_payment[i] = iserte;
          }
          this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

          this.changallpaid();
          this.changeallremain();
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        //console.log(userRoles.indexOf('pos.invoices.' + role));
        if (userRoles.indexOf('pos.invoices.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteRecieptVouchers(invoice: RecieptVouchers) {
      this.confirmationService.confirm({
          header: this.translate.instant('Confirm Delete'),
          message: this.translate.instant('Are you sure of delete ?'),
          icon: 'fa fa-trash',
          accept: () => {
            if (invoice) {
              this.invoiceService.delete(invoice.id).subscribe(
                res => {
                  this.msgs = [];
                  if(res.result){
                    this.msgs.push({
                      severity: 'success',
                      summary: '',
                      detail: this.translate.instant('Delete completed')
                    });
                    setTimeout(() => {
                      this.router.navigate(['/reciept_vouchers']);
                    },1000);
                  }
                  else{
                    this.msgs.push({
                      severity: 'error',
                      summary: '',
                      detail: this.translate.instant(res.message)
                    });
                  }
                  localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  window.scroll(0,0);
                }
              );
            }
          }
      });
    }

    recoverEdit(invoice: any) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (invoice) {
                    this.invoiceService.update(invoice).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/reciept_vouchers/show', invoice.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.invoiceService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted invoice recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/reciept_vouchers/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    //console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;

    }
  }
  showHistory(row_id: string) {
     // console.log("12121212");
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppLogComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.refShow = RecieptVouchersShowComponent;
    }
  }


  changallpaid(){
     // console.log("ooooooooo");
    this.allpaid=0.0;
    for(let i=0; i<this.Selected_payment.length; i++){
      this.allpaid += parseFloat(this.Selected_payment[i].payment_amount);
    }
    let discv = 0;
    let disct =  0;

    this.allremain = (parseFloat(this.allcost_a_tax )- parseFloat(this.allpaid )).toFixed(2);

  }
  changeallremain(){
    this.allremain=0.0;
    this.allquty=0.0;
    this.allcostsforone=0.0;
    this.allcost_b_tax=0.0;
    this.allcost_a_tax=0.0;
    this.alltaxes=0.0;
    for(let i=0; i<this.Selected_items.length; i++){
      this.allquty += parseFloat(this.Selected_items[i].qty);
      this.allcostsforone += parseFloat(this.Selected_items[i].cost);
      this.allcost_b_tax +=  parseFloat(this.Selected_items[i].totalBtax);
      this.allcost_a_tax +=  parseFloat(this.Selected_items[i].amount);
      this.alltaxes +=  parseFloat(this.Selected_items[i].taxvalue);

    }
    this.allcost_a_tax = parseFloat(this.allcost_a_tax).toFixed(2);

    let discv = 0;
    let disct =  0;

    this.allremain = (parseFloat(this.allcost_a_tax ) - parseFloat(this.allpaid )).toFixed(2);
  }

  changealldiscount(){
    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;

    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }
    this.changeallremain();


  }

  openpopup(doc,type) {
    console.log(doc);
    if(type === 0) {
      const modalRef = this.modalService.open(JournalsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 2) {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 3){
      const modalRef = this.modalService.open(RefundsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 4){
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 5){
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 6){
      const modalRef = this.modalService.open(RecieptVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 7){
      const modalRef = this.modalService.open(ExpenseVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/views/fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component.ts